export default function FlexColumn({ style, children, ...props }) {
	return (
		<div style={{ display: "flex", flexDirection: "column", ...style }} {...props}>
			{children}
		</div>
	);
}
